import "../styles/CallConfirmed.scss";
import LoomEmbed from "../components/LoomEmbed";

const VIDEO_URL = "https://www.loom.com/embed/1fccb9dd34e34a3baeaf5af75802d8f6";

const CallConfirmed = () => (
    <div className="lead-page">
        <main className="lead-main lead-body--center">
            <p className="lead-badge">Important. Keep this page open</p>

            <h1 className="lead-h1">Call confirmed</h1>

            <p className="lead-lede">
                Before we speak, watch this short video from me — it'll make our thirty
                minutes together far more useful.
            </p>

            <section style={{ marginTop: "3.5rem" }}>
                <LoomEmbed url={VIDEO_URL} title="A message from Kevin before your call" />
            </section>

            <p className="lead-footnote">Podsy turns your listeners into people you can actually talk to.</p>
        </main>
    </div>
);

export default CallConfirmed;
